import { paymentTechErrorCodes } from 'constants/errors';

// getPaymentTechError is no longer the main handler for gateway error messages, but leaving in in case of future use.
// The current implementation of error codes is within errorCodeDescriptions. This renders on the PageOrderError page.
export const getPaymentTechError = (code: string) => paymentTechErrorCodes?.[code] || null;
